module.exports = __webpack_public_path__ + "img/right-from-bracket.59f41cb8.svg";